import { Alert, AlertModal, Button } from '@sixfold/common-ui';
import React from 'react';

interface Props {
  open: boolean;
  memberName: string;
  hubName: string;
  isSaving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const CompanyGroupLinkConfirmModal: React.FC<Props> = ({
  open,
  memberName,
  hubName,
  isSaving,
  onCancel,
  onConfirm,
}) => (
  <AlertModal
    open={open}
    onClose={() => !isSaving && onCancel()}
    trigger={null}
    title={`Add ${memberName} to the company group?`}
    description={
      <Alert kind="danger">
        Linking {memberName} to hub {hubName} immediately shares all carriers and subcontractors across every account in
        the group. This cannot be undone!
      </Alert>
    }>
    <Button kind="subtle" onClick={onCancel} disabled={isSaving}>
      Cancel
    </Button>
    <Button kind="danger" onClick={onConfirm} disabled={isSaving} loading={isSaving}>
      Yes, add account
    </Button>
  </AlertModal>
);
